import React from "react"
import LandingFrame from "../components/LandingFrame"

const Downloads: React.FC = () => (
  <LandingFrame src="/landing/downloads.html" title="Sendy - Downloads" />
)

export default Downloads
